function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyAccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import SegmentTablesComponent from '@/apps/audiences/components/SegmentTablesComponent';
import firebase from 'firebase';
import { mapState, mapMutations } from 'vuex';
import { ARRAY_TYPE_ELEMENTS, TYPE_ELEMENTS, ROLES_LIST, GA_EVENTS } from '@/js/constants';
export default {
  name: 'EditAttributeMaster',
  components: {
    SegmentTablesComponent: SegmentTablesComponent
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {
        id: this.item.id,
        description_es: this.item.description_es,
        description_en: this.item.description_en,
        name_es: this.item.name_es,
        name_en: this.item.name_en,
        attribute_object_name: this.item.attribute_object_name,
        attribute_scheme_name: this.item.attribute_scheme_name,
        attribute_project_name: this.item.attribute_project_name,
        attribute_group_design: this.item.attribute_group_design,
        alias: this.item.alias,
        photoURL: null
      },
      files: [],
      valid: false,
      // columns_selected: [],
      viewsData: [],
      tableSearch: {},
      serviceAccount: 'dev-itc-dp-bigquery-work@dev-intercorp-data-operation.iam.gserviceaccount.com',
      // isValidatingTable: false,
      // items: [],
      // partyId: null,
      // baseID: {},
      // keySearchTable: 1
      isLoadingProfile: false,
      isUploadingImage: false,
      selectedImage: null,
      uploadValue: 0
    };
  },
  created: function created() {
    //this.getObjectAccess()
  },
  methods: {
    onFileChanged: function onFileChanged(event) {
      this.selectedImage = event;
      this.form.photoURL = URL.createObjectURL(this.selectedImage);
      this.isUploadingImage = true;
    },
    onSubmit: function onSubmit(event) {
      var _this = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      if (this.isUploadingImage) {
        var uploadPromise = new Promise(function (resolve, reject) {
          if (_this.selectedImage) {
            var storageRef = firebase.storage().ref("attributes_marketplace/".concat(_this.selectedImage.name)).put(_this.selectedImage);
            storageRef.on('state_changed', function (snapshot) {
              _this.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
              console.log(_this.uploadValue);
            }, function (error) {
              console.error(error.message);
            }, function () {
              _this.uploadValue = 100;
              storageRef.snapshot.ref.getDownloadURL().then(function (url) {
                console.log("Image url: ".concat(url));
                _this.isUploadingImage = false;
                _this.form.photoURL = url;
                _this.form.attribute_group_design = url;
                resolve();
              }).catch(function (error) {
                reject(error);
              });
            });
          } else {
            resolve();
          }
        });
        uploadPromise.then(function () {
          _this.$emit('SubmitEditMaster', _this.form);
        });
      } else {
        this.$emit('SubmitEditMaster', this.form);
      }
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.EDIT_ATTRIBUTE_CATEGORY,
          category_name: this.form.name_es,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          module: 'attributes_marketplace'
        });
      }
    },
    getObjectAccess: function getObjectAccess() {
      var _this2 = this;
      this.viewsData = [];
      var params = {
        user: this.serviceAccount
      };
      MyAccessService.getObjectAccess('attributes', params).then(function (response) {
        console.log(response);
        if (response && response.data) {
          response.data.forEach(function (element) {
            _this2.viewsData.push({
              text: element.table.id,
              value: element.view.projectId + '.' + element.view.datasetId + '.' + element.view.objectId,
              data: element
            });
          });
        }
      });
    },
    onTableSelected: function onTableSelected() {
      // console.log('tableSearch')
      // console.log(this.tableSearch)
      // console.log(this.tableSearch.data.table.datasetId)
      // console.log(this.tableSearch.data.table.objectId)
      // console.log(this.tableSearch.data.table.projectId)
      if (Object.keys(this.tableSearch).length > 0) {
        this.form.attribute_object_name = this.tableSearch.data.table.objectId;
        this.form.attribute_project_name = this.tableSearch.data.table.projectId;
        this.form.attribute_scheme_name = this.tableSearch.data.table.datasetId;
      }
      // if (this.viewsData.length > 0 && Object.keys(this.tableSearch).length > 0) {
      //   const params = {
      //     relativeResourceName: this.tableSearch.data.relativeResourceName,
      //     domain_table: this.tableSearch.data.domain
      //   }
      //   AssignmentsService.getListTagEntry(params)
      //     .then((response) => {
      //       if (response && response.code === 200) {
      //         console.log('---------------------')
      //         console.log(response)
      //         // const responseTPL = response.data
      //         // const tableTags = responseTPL.objects.tags
      //         // const columnTags = tableTags.filter(tag => !!tag.column)
      //         // this.items = columnTags
      //         // this.columns_selected = []
      //         // this.partyId = null
      //         // this.keySearchTable += 1
      //         // this.$refs.form.resetValidation()
      //       }
      //     })
      // }
    },
    // onSubmit(event) {
    // event.preventDefault()
    // if (!this.validate()) {
    //   return
    // }
    // this.$emit('SubmitEditMaster', this.form)
    // }
    validate: function validate() {
      return this.$refs.form.validate();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode'])), {}, {
    rules: function rules() {
      var _this3 = this;
      return {
        name_es: [function (v) {
          return !!v || _this3.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 50 || _this3.translate('reglas.nombre_max');
        }],
        description_es: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.field_min');
        }, function (v) {
          return v && v.length <= 200 || _this3.translate('reglas.field_max');
        }],
        name_en: [function (v) {
          return !!v || _this3.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 50 || _this3.translate('reglas.nombre_max');
        }],
        description_en: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this3.translate('reglas.field_min');
        }, function (v) {
          return v && v.length <= 200 || _this3.translate('reglas.field_max');
        }],
        alias: [function (v) {
          return !!v || _this3.translate('reglas.alias');
        }],
        attribute_group_design: [function (value) {
          return !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!';
        }],
        attribute_project_name: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }],
        attribute_scheme_name: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }],
        attribute_object_name: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }]
      };
    }
  })
};